import styled from 'styled-components'
import { TituloH1 as TituloPrincipal, Descricao } from '../../../../components/TituloSorriso/styles'
import { media } from '../../../../layouts/utils'

export const Wrapper = styled.div`
  ${media.phone`
    height: 400px;
  `}
  position: relative;
  width: 100%;
  background-color: #fff;
  height: 300px;
`

export const Container = styled.div`
  ${media.desktop`
    display: block;
    width: 100%;
    padding: 5px;
    margin: 0;
    text-align: center;
  `}
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 10rem;
  ${media.phone`
    position: relative;
  `}
`

export const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  ${media.desktop`
    align-items: center;
    justify-content: center;
  `}
  .botaoTagVeloe {
		${media.phone`
			position: absolute;
			top: 280px;

 	 	`}
	}
`

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    text-align: center;
    max-width: 250px;
    line-height: 28px;
    margin-top: 20px;
  `}
  padding: 0;
  padding-bottom: 10px;
  text-align: left;
  max-width: 500px;
  line-height: 42px;
  color: ${(props) => props.color};
  ${media.phone`
    position: absolute;
    top: 0;
    text-align: left;
    font-size: 24px;
    max-width: 280px;
    line-height: 30px;
  `}
`

export const Text = styled(Descricao)`
  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  `}
  padding: 0;
  text-align: left;
  max-width: 400px;
`

export const Image = styled.img`
  ${media.desktop`
    text-align: left;
    width: 100%;
    max-width: 338px;
    height: auto;
    margin-top: 7px;
  `}
  width: 100%;
  max-width: 338px;
  ${media.phone`
		position: absolute;
    max-width: 250px;
		top: 180px;
    left:80px;

  `}
  ${media.smallPhone`
    position: absolute;
    max-width: 250px;
    top: 180px;
    left:35px;
  `}
`